import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { 
  GET_ENQUIRY_RESPONSES,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';

export default {
  name: 'Leads',
  mixins: [alert_mixin , formatting_mixins],
  components:{
    AICampusFooter
  },
  data: () => ({ 
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    enquiry_form_id: '',
    selected_status: 'in-progress', 
    show_log_modal: false,
    selected_lead: null,
    lead_responses: [],
    status_cards: [
      { title: 'New Lead', color_class: 'orange-text', type: 'in-progress', icon: 'fa-regular fa-hourglass-half', count: 0 },
      { title: 'Qualified', color_class: 'green-text', type: 'submitted', icon: 'fa-solid fa-check-double', count: 0 },
      { title: 'Negotiation', color_class: 'text-danger', type: 'awaiting-verification', icon: 'fa-regular fa-clock', count: 0 },
      { title: 'Approved', color_class: 'text-info', type: 'approved', icon: 'fa-solid fa-thumbs-up', count: 0 },
      { title: 'Closed', color_class: 'text-secondary', type: 'closed', icon: 'fa-solid fa-lock', count: 0 }
    ],
    table_headers: ['Lead ID', 'Name', 'Email', 'Phone', 'Date Created', 'Status', 'Actions'],
    leads_list: [],
    is_loading: false,
    dataTable: null,
    enquiry_status: '',
  }),
  computed: {
    filtered_leads() {
      return this.leads_list.filter(
        (lead) => lead.Status.toLowerCase() === this.selected_status
      );
    }
  },
  mounted() {
    this.enquiry_form_id = sessionStorage.getItem('enquiry_form_id');
    this.enquiry_status = this.$route.query.status || 'in-progress';
    this.get_all_leads();
  },
  watch: {
    "$route.query.status"() {
      this.enquiry_status = this.$route.query.status || 'New Lead';
      this.get_all_leads();
    },
    
  },
  methods: {
    init_data_table() {
      if (this.dataTable) {
        this.dataTable.destroy();
      }
      
      this.dataTable = $('#leads_table').DataTable({
        responsive: true,
        emptyTable: "No data available in table",
        language: {
          info: "", // Capitalized "Entries"
          lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
        }
      });
    },
    
    select_status(status) {
      this.selected_status = status;
    },

    process_leads_data(leads_data) {
      return leads_data.map(lead => {
        const questions = lead.questions;
        
        // Find each field by checking question_text 
        const first_name = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('first name'))?.answer || 'N/A';
        const last_name = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('last name'))?.answer || 'N/A';
        const email = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('email'))?.answer || 'N/A';
        const phone = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('phone'))?.answer || 'N/A';
        
        const submission_dates = Object.values(questions).map(question => new Date(question.submitted_at));
        const earliest_date = submission_dates.length ? new Date(Math.min(...submission_dates)) : null;
        
        return {
          id: lead.lead_id,
          'Lead ID': lead.lead_id,
          'Name': `${first_name} ${last_name}`.trim(),
          'Email': email,
          'Phone': phone,
          'Date Created': earliest_date ? this.format_date(earliest_date) : '',
          'Status': 'in-progress',
          questions: questions
        };
      });
    },

    update_status_counts() {
      this.status_cards = this.status_cards.map(card => (
        { ...card, count: this.leads_list.filter(lead => lead.Status === card.type).length }
      ));
    },
    
    

    get_all_leads() {
      this.is_loading = true;
      const params = {
        project_id: this.project_id,
        status: this.enquiry_status,

      };

      axios.get(GET_ENQUIRY_RESPONSES, { params: params, headers: this.headers })
        .then(response => {
          if (response.data.status === 'success') {
            this.leads_list = this.process_leads_data(response.data.data);
            this.update_status_counts();
          } else {
            this.show_error('Failed to load leads');
          }
        })
        .catch(error => {
          this.show_error(`Error fetching leads: ${error.response?.data?.message}`);
        })
        .finally(() => {
          this.is_loading = false;
        });
    }
  },
  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  },
};

